import { useState, useEffect } from "react";
import { useApiCall } from "./useApiCall";

export const useProductRecommendations = () => {
  const [productRecommendations, setProductRecommendations] = useState([]);
  const [productRecommendationsError, setProductRecommendationsError] =
    useState();
  const [productRecommendationsStatus, setProductRecommendationsStatus] =
    useState("idle");

  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();

  const fetchProductRecommendations = ({ productId, productIds }) => {
    if (!productId && !productIds?.length) {
      return;
    }

    let url = "";

    if (productId) {
      url = `/products/recommendations?productId=${productId}`;
    }

    if (!productId && productIds) {
      url = `/products/recommendations?productIds=${JSON.stringify(
        productIds
      )}`;
    }

    if (!url) {
      return;
    }

    const requestOptions = {
      url,
    };

    executeApiCall(requestOptions);

    setProductRecommendationsStatus("pending");
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse.data.data) {
          const { recommendations } = apiCallResponse.data.data;

          setProductRecommendations(recommendations);
          setProductRecommendationsStatus("ready");
        } else {
          setProductRecommendationsError(
            apiCallResponse.data.error.userMessage
          );
          setProductRecommendationsStatus("ready");
        }
        break;
      case "error":
        setProductRecommendationsStatus("ready");
        break;
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    productRecommendations,
    productRecommendationsError,
    productRecommendationsStatus,
    fetchProductRecommendations,
  };
};
